import { useContext } from 'react';
import { NewProjectContext } from '../pages';

export function useNewProject() {
  const context = useContext(NewProjectContext);
  return { ...context };
}

export default useNewProject;
